import type { II18nRepository } from '../repositories/i18n.repository'
import type { LocaleMessages } from '../repositories/i18n.repository'

/** Код локали по умолчанию */
export const DEFAULT_LOCALE = 'ro'

export const SUPPORTED_LOCALES = ['ro', 'ru', 'en'] as const
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]

/**
 * Доменный сервис локализации.
 * Управляет выбором локали по умолчанию и загрузкой сообщений через репозиторий.
 */
export class I18nService {
  private static instance: I18nService | null = null

  constructor(private readonly i18nRepository: II18nRepository) {}

  static getInstance(i18nRepository: II18nRepository): I18nService {
    if (!I18nService.instance) {
      I18nService.instance = new I18nService(i18nRepository)
    }
    return I18nService.instance
  }

  static resetInstance(): void {
    I18nService.instance = null
  }

  /** Локаль по умолчанию */
  getDefaultLocale(): string {
    return DEFAULT_LOCALE
  }

  /** Список поддерживаемых локалей */
  getSupportedLocales(): readonly string[] {
    return SUPPORTED_LOCALES
  }

  /**
   * Загрузить сообщения локали по умолчанию
   */
  async loadDefaultLocale(): Promise<LocaleMessages> {
    return this.i18nRepository.loadMessages(DEFAULT_LOCALE)
  }

  /**
   * Загрузить сообщения для указанной локали
   */
  async loadLocale(locale: string): Promise<LocaleMessages> {
    return this.i18nRepository.loadMessages(locale)
  }
}
